import React from 'react'
import { post } from "../../services/http";
import CampoDeComentario from "./campoDeComentario";

const comentar = async ({ contexto, comentario, link }) =>
    post(`/comentario`, { contexto, comentario, link })

export default props =>
    <CampoDeComentario acao={comentar}  prepend={true} {...props} />
